export default __webpack_public_path__ + "static/media/z.44f0bb0b.png";